import { Injectable } from "@angular/core";
import { ConstantsService } from "./constants.service";
import { AuthService } from "./auth.service";
import { DashboardModel } from "../models/dashboard-model";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class ModeratorDashboardService {
  constructor(
    private readonly _http: HttpClient,
    private readonly _constants: ConstantsService,
    private readonly _auth: AuthService
  ) {}

  getDashboard(): Observable<DashboardModel> {
    const url = this._constants.apiUrl + "Dashboard/GetDashboardForModerator/";
    return <Observable<DashboardModel>>this._http.get(url, this._auth.getOptions2(true));
  }
}
